// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptEstimationData, AcceptEstimationErrors, AcceptEstimationResponses, AttachDatapointToEstimationData, AttachDatapointToEstimationErrors, AttachDatapointToEstimationResponses, AttachDatapointToWorkbookData, AttachDatapointToWorkbookErrors, AttachDatapointToWorkbookResponses, CloneEstimationsData, CloneEstimationsErrors, CloneEstimationsResponses, CreateActivityData, CreateActivityErrors, CreateActivityResponses, CreateOrCloneEstimationData, CreateOrCloneEstimationErrors, CreateOrCloneEstimationResponses, CreateTaxonData, CreateTaxonErrors, CreateTaxonResponses, DeleteActivityData, DeleteActivityErrors, DeleteActivityResponses, DeleteBranchData, DeleteBranchErrors, DeleteBranchResponses, DeleteDatapointData, DeleteDatapointErrors, DeleteDatapointResponses, DeleteEstimationData, DeleteEstimationErrors, DeleteEstimationResponses, DeleteTaxonData, DeleteTaxonErrors, DeleteTaxonResponses, DeleteWorkbookEntryData, DeleteWorkbookEntryErrors, DeleteWorkbookEntryResponses, DeliberateErrorKaboomGetData, DeliberateErrorKaboomGetResponses, DetachDatapointFromEstimationData, DetachDatapointFromEstimationErrors, DetachDatapointFromEstimationResponses, EditWorkbookEntryData, EditWorkbookEntryErrors, EditWorkbookEntryResponses, GetActivityData, GetActivityErrors, GetActivityResponses, GetActivitySummariesData, GetActivitySummariesErrors, GetActivitySummariesResponses, GetDatapointData, GetDatapointErrors, GetDatapointGraphData, GetDatapointGraphErrors, GetDatapointGraphResponses, GetDatapointResponses, GetEstimationsForEntityAndTechnologyData, GetEstimationsForEntityAndTechnologyErrors, GetEstimationsForEntityAndTechnologyResponses, GetLatestActivityData, GetLatestActivityErrors, GetLatestActivityResponses, GetLatestSegmentMappingsData, GetLatestSegmentMappingsErrors, GetLatestSegmentMappingsResponses, GetLatestTaxonData, GetLatestTaxonErrors, GetLatestTaxonResponses, GetOutcomesPerSdgForActivityData, GetOutcomesPerSdgForActivityErrors, GetOutcomesPerSdgForActivityResponses, GetSegmentMappingsData, GetSegmentMappingsErrors, GetSegmentMappingsResponses, GetTaxonBaselinesData, GetTaxonBaselinesErrors, GetTaxonBaselinesResponses, GetTaxonData, GetTaxonEntitiesData, GetTaxonEntitiesErrors, GetTaxonEntitiesOptionsData, GetTaxonEntitiesOptionsErrors, GetTaxonEntitiesOptionsResponses, GetTaxonEntitiesResponses, GetTaxonErrors, GetTaxonResponses, GetTaxonSolutionsData, GetTaxonSolutionsErrors, GetTaxonSolutionsResponses, GetTheoryOfChangeForActivityData, GetTheoryOfChangeForActivityErrors, GetTheoryOfChangeForActivityResponses, GetWorkbookData, GetWorkbookErrors, GetWorkbookGraphData, GetWorkbookGraphErrors, GetWorkbookGraphResponses, GetWorkbookResponses, HealthCheckHealthyGetData, HealthCheckHealthyGetResponses, ListActivitiesData, ListActivitiesErrors, ListActivitiesMinimalData, ListActivitiesMinimalErrors, ListActivitiesMinimalResponses, ListActivitiesResponses, ListDatapointsData, ListDatapointsErrors, ListDatapointsResponses, ListEstimationsData, ListEstimationsErrors, ListEstimationsResponses, ListLatestActivitiesData, ListLatestActivitiesErrors, ListLatestActivitiesResponses, ListLatestTaxonomiesByTypeData, ListLatestTaxonomiesByTypeErrors, ListLatestTaxonomiesByTypeResponses, ListLatestTaxonomiesData, ListLatestTaxonomiesErrors, ListLatestTaxonomiesResponses, ListTaxonomiesByTypeData, ListTaxonomiesByTypeErrors, ListTaxonomiesByTypeResponses, ListTaxonomiesData, ListTaxonomiesErrors, ListTaxonomiesResponses, ListTechnologyCostsData, ListTechnologyCostsErrors, ListTechnologyCostsResponses, RejectEstimationData, RejectEstimationErrors, RejectEstimationResponses, SearchRelatedDatapointsData, SearchRelatedDatapointsErrors, SearchRelatedDatapointsResponses, UpdateActivityData, UpdateActivityErrors, UpdateActivityResponses, UpdateDatapointData, UpdateDatapointErrors, UpdateDatapointResponses, UpdateReportingEndDateData, UpdateReportingEndDateErrors, UpdateReportingEndDateResponses, UpdateTaxonData, UpdateTaxonErrors, UpdateTaxonResponses, UpsertWorkbookData, UpsertWorkbookErrors, UpsertWorkbookResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class ActivitiesService {
    /**
     * List Activity Summaries
     *
     * You can filter results, e.g.
     * q=activity_id=access_to_broadband_developed_markets
     * q=activity_name=Better cotton
     * q=domain=Bioplastic
     */
    public static getActivitySummaries<ThrowOnError extends boolean = true>(options?: Options<GetActivitySummariesData, ThrowOnError>): RequestResult<GetActivitySummariesResponses, GetActivitySummariesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetActivitySummariesResponses, GetActivitySummariesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/summary',
            ...options
        });
    }
    
    /**
     * List Activities
     *
     * You can filter results, e.g.
     * q=activity_id=access_to_broadband_developed_markets
     * q=activity_name=Better cotton
     * q=domain=Bioplastic
     */
    public static listActivities<ThrowOnError extends boolean = true>(options?: Options<ListActivitiesData, ThrowOnError>): RequestResult<ListActivitiesResponses, ListActivitiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListActivitiesResponses, ListActivitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities',
            ...options
        });
    }
    
    /**
     * Create Activity
     */
    public static createActivity<ThrowOnError extends boolean = true>(options: Options<CreateActivityData, ThrowOnError>): RequestResult<CreateActivityResponses, CreateActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateActivityResponses, CreateActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Latest Activities
     *
     * You can filter results, e.g.
     * q=activity_id=access_to_broadband_developed_markets
     * q=activity_name=Better cotton
     * q=domain=Bioplastic
     */
    public static listLatestActivities<ThrowOnError extends boolean = true>(options?: Options<ListLatestActivitiesData, ThrowOnError>): RequestResult<ListLatestActivitiesResponses, ListLatestActivitiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListLatestActivitiesResponses, ListLatestActivitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/latest',
            ...options
        });
    }
    
    /**
     * List Minimal Activities
     *
     * You can filter results, e.g.
     * q=activity_id=access_to_broadband_developed_markets
     * q=activity_name=Better cotton
     * q=domain=Bioplastic
     */
    public static listActivitiesMinimal<ThrowOnError extends boolean = true>(options?: Options<ListActivitiesMinimalData, ThrowOnError>): RequestResult<ListActivitiesMinimalResponses, ListActivitiesMinimalErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListActivitiesMinimalResponses, ListActivitiesMinimalErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/minimal',
            ...options
        });
    }
    
    /**
     * Delete Activity
     *
     * Deletes an activity and all associated costs.
     * Returns 405 if there are estimations for this activity, or if any of its costs
     * are referenced by the formula of a datapoint in another workbook.
     */
    public static deleteActivity<ThrowOnError extends boolean = true>(options: Options<DeleteActivityData, ThrowOnError>): RequestResult<DeleteActivityResponses, DeleteActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteActivityResponses, DeleteActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/{activity_id}',
            ...options
        });
    }
    
    /**
     * Get Activity
     */
    public static getActivity<ThrowOnError extends boolean = true>(options: Options<GetActivityData, ThrowOnError>): RequestResult<GetActivityResponses, GetActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetActivityResponses, GetActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/{activity_id}',
            ...options
        });
    }
    
    /**
     * Update Activity
     */
    public static updateActivity<ThrowOnError extends boolean = true>(options: Options<UpdateActivityData, ThrowOnError>): RequestResult<UpdateActivityResponses, UpdateActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateActivityResponses, UpdateActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/{activity_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Latest Activity
     */
    public static getLatestActivity<ThrowOnError extends boolean = true>(options: Options<GetLatestActivityData, ThrowOnError>): RequestResult<GetLatestActivityResponses, GetLatestActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetLatestActivityResponses, GetLatestActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/activities/{activity_id}/latest',
            ...options
        });
    }
}

export class ActivityCostsService {
    /**
     * List Costs
     */
    public static listTechnologyCosts<ThrowOnError extends boolean = true>(options?: Options<ListTechnologyCostsData, ThrowOnError>): RequestResult<ListTechnologyCostsResponses, ListTechnologyCostsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListTechnologyCostsResponses, ListTechnologyCostsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/costs',
            ...options
        });
    }
}

export class DatapointsService {
    /**
     * List Datapoints
     */
    public static listDatapoints<ThrowOnError extends boolean = true>(options?: Options<ListDatapointsData, ThrowOnError>): RequestResult<ListDatapointsResponses, ListDatapointsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListDatapointsResponses, ListDatapointsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/datapoints',
            ...options
        });
    }
    
    /**
     * Search Datapoints
     *
     * Find datapoints in the system.
     */
    public static searchRelatedDatapoints<ThrowOnError extends boolean = true>(options?: Options<SearchRelatedDatapointsData, ThrowOnError>): RequestResult<SearchRelatedDatapointsResponses, SearchRelatedDatapointsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<SearchRelatedDatapointsResponses, SearchRelatedDatapointsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/datapoints/search_related',
            ...options
        });
    }
    
    /**
     * Delete Datapoint
     */
    public static deleteDatapoint<ThrowOnError extends boolean = true>(options: Options<DeleteDatapointData, ThrowOnError>): RequestResult<DeleteDatapointResponses, DeleteDatapointErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteDatapointResponses, DeleteDatapointErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/datapoints/{datapoint_id}',
            ...options
        });
    }
    
    /**
     * Get Datapoint
     */
    public static getDatapoint<ThrowOnError extends boolean = true>(options: Options<GetDatapointData, ThrowOnError>): RequestResult<GetDatapointResponses, GetDatapointErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetDatapointResponses, GetDatapointErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/datapoints/{datapoint_id}',
            ...options
        });
    }
    
    /**
     * Update Datapoint
     */
    public static updateDatapoint<ThrowOnError extends boolean = true>(options: Options<UpdateDatapointData, ThrowOnError>): RequestResult<UpdateDatapointResponses, UpdateDatapointErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateDatapointResponses, UpdateDatapointErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/datapoints/{datapoint_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Datapoint Graph
     */
    public static getDatapointGraph<ThrowOnError extends boolean = true>(options: Options<GetDatapointGraphData, ThrowOnError>): RequestResult<GetDatapointGraphResponses, GetDatapointGraphErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetDatapointGraphResponses, GetDatapointGraphErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/datapoints/{datapoint_id}/graph',
            ...options
        });
    }
}

export class EstimationsService {
    /**
     * List Estimations
     */
    public static listEstimations<ThrowOnError extends boolean = true>(options?: Options<ListEstimationsData, ThrowOnError>): RequestResult<ListEstimationsResponses, ListEstimationsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListEstimationsResponses, ListEstimationsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations',
            ...options
        });
    }
    
    /**
     * Create New Estimation
     *
     * If the estimation.clone_from field is set, it will check the entity_id and
     * technology_id match what is provided, then clone.
     */
    public static createOrCloneEstimation<ThrowOnError extends boolean = true>(options: Options<CreateOrCloneEstimationData, ThrowOnError>): RequestResult<CreateOrCloneEstimationResponses, CreateOrCloneEstimationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateOrCloneEstimationResponses, CreateOrCloneEstimationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Estimation Detail View
     *
     * Returns estimations for given `entity_id` and `technology_id` with all
     * possible impact branches combined.
     */
    public static getEstimationsForEntityAndTechnology<ThrowOnError extends boolean = true>(options: Options<GetEstimationsForEntityAndTechnologyData, ThrowOnError>): RequestResult<GetEstimationsForEntityAndTechnologyResponses, GetEstimationsForEntityAndTechnologyErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEstimationsForEntityAndTechnologyResponses, GetEstimationsForEntityAndTechnologyErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{entity_id}/{technology_id}',
            ...options
        });
    }
    
    /**
     * Clone Estimations
     *
     * If the destination entity already has an estimation
     * for a given technology_id and reporting_date, we do
     * not recreate it.
     */
    public static cloneEstimations<ThrowOnError extends boolean = true>(options: Options<CloneEstimationsData, ThrowOnError>): RequestResult<CloneEstimationsResponses, CloneEstimationsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CloneEstimationsResponses, CloneEstimationsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/clone',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Accept Estimation
     *
     * Mark a branch or the trunk of the estimation as accepted.
     *
     * If `impact_theme` is `null`, the trunk will be accepted. Otherwise, this accepts
     * the branch matching the given impact theme.
     *
     * Note: Accepting a branch also automatically accepts the trunk.
     */
    public static acceptEstimation<ThrowOnError extends boolean = true>(options: Options<AcceptEstimationData, ThrowOnError>): RequestResult<AcceptEstimationResponses, AcceptEstimationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<AcceptEstimationResponses, AcceptEstimationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}/{impact_theme}/accept',
            ...options
        });
    }
    
    /**
     * Reject Estimation
     *
     * Mark a branch or the trunk of the estimation as created.
     *
     * If `impact_theme` is `null`, the trunk will be rejected. Otherwise, this rejects
     * the branch matching the given impact theme.
     */
    public static rejectEstimation<ThrowOnError extends boolean = true>(options: Options<RejectEstimationData, ThrowOnError>): RequestResult<RejectEstimationResponses, RejectEstimationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<RejectEstimationResponses, RejectEstimationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}/{impact_theme}/reject',
            ...options
        });
    }
    
    /**
     * Delete Estimation
     */
    public static deleteEstimation<ThrowOnError extends boolean = true>(options: Options<DeleteEstimationData, ThrowOnError>): RequestResult<DeleteEstimationResponses, DeleteEstimationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteEstimationResponses, DeleteEstimationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}',
            ...options
        });
    }
    
    /**
     * Unattach Datapoint From Estimation
     */
    public static detachDatapointFromEstimation<ThrowOnError extends boolean = true>(options: Options<DetachDatapointFromEstimationData, ThrowOnError>): RequestResult<DetachDatapointFromEstimationResponses, DetachDatapointFromEstimationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DetachDatapointFromEstimationResponses, DetachDatapointFromEstimationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}/datapoints',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Attach Datapoint To Estimation
     */
    public static attachDatapointToEstimation<ThrowOnError extends boolean = true>(options: Options<AttachDatapointToEstimationData, ThrowOnError>): RequestResult<AttachDatapointToEstimationResponses, AttachDatapointToEstimationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<AttachDatapointToEstimationResponses, AttachDatapointToEstimationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}/datapoints',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Branch
     *
     * Delete all workbook entries for a given impact theme and estimation.
     * Associated datapoints are still kept.
     */
    public static deleteBranch<ThrowOnError extends boolean = true>(options: Options<DeleteBranchData, ThrowOnError>): RequestResult<DeleteBranchResponses, DeleteBranchErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteBranchResponses, DeleteBranchErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}/{impact_theme}',
            ...options
        });
    }
    
    /**
     * Update Reporting End Date
     *
     * Weirdly - reporting-end-date is about the only field worth being able to update
     */
    public static updateReportingEndDate<ThrowOnError extends boolean = true>(options: Options<UpdateReportingEndDateData, ThrowOnError>): RequestResult<UpdateReportingEndDateResponses, UpdateReportingEndDateErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateReportingEndDateResponses, UpdateReportingEndDateErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/{estimation_id}/reporting-end-date/{reporting_end_date}',
            ...options
        });
    }
}

export class TaxonomiesService {
    /**
     * List Taxonomy
     */
    public static listTaxonomies<ThrowOnError extends boolean = true>(options?: Options<ListTaxonomiesData, ThrowOnError>): RequestResult<ListTaxonomiesResponses, ListTaxonomiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListTaxonomiesResponses, ListTaxonomiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy',
            ...options
        });
    }
    
    /**
     * Create Taxonomy
     */
    public static createTaxon<ThrowOnError extends boolean = true>(options: Options<CreateTaxonData, ThrowOnError>): RequestResult<CreateTaxonResponses, CreateTaxonErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateTaxonResponses, CreateTaxonErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Latest Taxononmy
     */
    public static listLatestTaxonomies<ThrowOnError extends boolean = true>(options?: Options<ListLatestTaxonomiesData, ThrowOnError>): RequestResult<ListLatestTaxonomiesResponses, ListLatestTaxonomiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListLatestTaxonomiesResponses, ListLatestTaxonomiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/latest',
            ...options
        });
    }
    
    /**
     * List Taxonomy By Type
     */
    public static listTaxonomiesByType<ThrowOnError extends boolean = true>(options: Options<ListTaxonomiesByTypeData, ThrowOnError>): RequestResult<ListTaxonomiesByTypeResponses, ListTaxonomiesByTypeErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListTaxonomiesByTypeResponses, ListTaxonomiesByTypeErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/type/{taxon_type}',
            ...options
        });
    }
    
    /**
     * List Latest Taxonomy By Type
     */
    public static listLatestTaxonomiesByType<ThrowOnError extends boolean = true>(options: Options<ListLatestTaxonomiesByTypeData, ThrowOnError>): RequestResult<ListLatestTaxonomiesByTypeResponses, ListLatestTaxonomiesByTypeErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListLatestTaxonomiesByTypeResponses, ListLatestTaxonomiesByTypeErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/type/{taxon_type}/latest',
            ...options
        });
    }
    
    /**
     * Delete Taxon
     */
    public static deleteTaxon<ThrowOnError extends boolean = true>(options: Options<DeleteTaxonData, ThrowOnError>): RequestResult<DeleteTaxonResponses, DeleteTaxonErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteTaxonResponses, DeleteTaxonErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}',
            ...options
        });
    }
    
    /**
     * Get Taxon
     */
    public static getTaxon<ThrowOnError extends boolean = true>(options: Options<GetTaxonData, ThrowOnError>): RequestResult<GetTaxonResponses, GetTaxonErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTaxonResponses, GetTaxonErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}',
            ...options
        });
    }
    
    /**
     * Update Taxon
     */
    public static updateTaxon<ThrowOnError extends boolean = true>(options: Options<UpdateTaxonData, ThrowOnError>): RequestResult<UpdateTaxonResponses, UpdateTaxonErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateTaxonResponses, UpdateTaxonErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Latest Taxon
     */
    public static getLatestTaxon<ThrowOnError extends boolean = true>(options: Options<GetLatestTaxonData, ThrowOnError>): RequestResult<GetLatestTaxonResponses, GetLatestTaxonErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetLatestTaxonResponses, GetLatestTaxonErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/latest',
            ...options
        });
    }
    
    /**
     * Get Taxon Entities
     *
     * Returns entities linked to the domain and the activities via which they are linked,
     * from revenue and outcomes.
     * Entities may have revenue linked directly to domain rather than via an activity, and
     * if there is no other activity then activities will be None.
     */
    public static getTaxonEntities<ThrowOnError extends boolean = true>(options: Options<GetTaxonEntitiesData, ThrowOnError>): RequestResult<GetTaxonEntitiesResponses, GetTaxonEntitiesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTaxonEntitiesResponses, GetTaxonEntitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/entities',
            ...options
        });
    }
    
    /**
     * Get Taxon Entities Options
     *
     * Returns the values for all options that can be used to filter entities for the
     * specified taxon_id.
     */
    public static getTaxonEntitiesOptions<ThrowOnError extends boolean = true>(options: Options<GetTaxonEntitiesOptionsData, ThrowOnError>): RequestResult<GetTaxonEntitiesOptionsResponses, GetTaxonEntitiesOptionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTaxonEntitiesOptionsResponses, GetTaxonEntitiesOptionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/entities/options',
            ...options
        });
    }
    
    /**
     * Get Outcomes Per Sdg For Activity
     */
    public static getOutcomesPerSdgForActivity<ThrowOnError extends boolean = true>(options: Options<GetOutcomesPerSdgForActivityData, ThrowOnError>): RequestResult<GetOutcomesPerSdgForActivityResponses, GetOutcomesPerSdgForActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetOutcomesPerSdgForActivityResponses, GetOutcomesPerSdgForActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/outcomes',
            ...options
        });
    }
    
    /**
     * Get Theory Of Change For Activity
     */
    public static getTheoryOfChangeForActivity<ThrowOnError extends boolean = true>(options: Options<GetTheoryOfChangeForActivityData, ThrowOnError>): RequestResult<GetTheoryOfChangeForActivityResponses, GetTheoryOfChangeForActivityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTheoryOfChangeForActivityResponses, GetTheoryOfChangeForActivityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/theory_of_change',
            ...options
        });
    }
    
    /**
     * Get Taxon Baselines
     */
    public static getTaxonBaselines<ThrowOnError extends boolean = true>(options: Options<GetTaxonBaselinesData, ThrowOnError>): RequestResult<GetTaxonBaselinesResponses, GetTaxonBaselinesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTaxonBaselinesResponses, GetTaxonBaselinesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/baseline',
            ...options
        });
    }
    
    /**
     * Get Taxon Solutions
     */
    public static getTaxonSolutions<ThrowOnError extends boolean = true>(options: Options<GetTaxonSolutionsData, ThrowOnError>): RequestResult<GetTaxonSolutionsResponses, GetTaxonSolutionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTaxonSolutionsResponses, GetTaxonSolutionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/{taxon_id}/solution',
            ...options
        });
    }
    
    /**
     * Get Segment Mappings
     */
    public static getSegmentMappings<ThrowOnError extends boolean = true>(options: Options<GetSegmentMappingsData, ThrowOnError>): RequestResult<GetSegmentMappingsResponses, GetSegmentMappingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSegmentMappingsResponses, GetSegmentMappingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/segment_mappings/{segment_id}',
            ...options
        });
    }
    
    /**
     * Get Latest Segment Mappings
     */
    public static getLatestSegmentMappings<ThrowOnError extends boolean = true>(options: Options<GetLatestSegmentMappingsData, ThrowOnError>): RequestResult<GetLatestSegmentMappingsResponses, GetLatestSegmentMappingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetLatestSegmentMappingsResponses, GetLatestSegmentMappingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/segment_mappings/{segment_id}/latest',
            ...options
        });
    }
}

export class WorkbooksService {
    /**
     * Delete Entry
     */
    public static deleteWorkbookEntry<ThrowOnError extends boolean = true>(options: Options<DeleteWorkbookEntryData, ThrowOnError>): RequestResult<DeleteWorkbookEntryResponses, DeleteWorkbookEntryErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteWorkbookEntryResponses, DeleteWorkbookEntryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workbooks/{workbook_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Workbook
     */
    public static getWorkbook<ThrowOnError extends boolean = true>(options: Options<GetWorkbookData, ThrowOnError>): RequestResult<GetWorkbookResponses, GetWorkbookErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetWorkbookResponses, GetWorkbookErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workbooks/{workbook_id}',
            ...options
        });
    }
    
    /**
     * Attach Datapoint To Workbook
     */
    public static attachDatapointToWorkbook<ThrowOnError extends boolean = true>(options: Options<AttachDatapointToWorkbookData, ThrowOnError>): RequestResult<AttachDatapointToWorkbookResponses, AttachDatapointToWorkbookErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<AttachDatapointToWorkbookResponses, AttachDatapointToWorkbookErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workbooks/{workbook_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Edit Workbook Entry
     */
    public static editWorkbookEntry<ThrowOnError extends boolean = true>(options: Options<EditWorkbookEntryData, ThrowOnError>): RequestResult<EditWorkbookEntryResponses, EditWorkbookEntryErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<EditWorkbookEntryResponses, EditWorkbookEntryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workbooks/{workbook_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upsert Workbook
     *
     * Upsert request on a workbook with datapoints. Will either create a new workbook, or
     * update the state of an existing one, so that it reflects the inbound status.
     */
    public static upsertWorkbook<ThrowOnError extends boolean = true>(options: Options<UpsertWorkbookData, ThrowOnError>): RequestResult<UpsertWorkbookResponses, UpsertWorkbookErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UpsertWorkbookResponses, UpsertWorkbookErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workbooks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Workbook Graph
     */
    public static getWorkbookGraph<ThrowOnError extends boolean = true>(options: Options<GetWorkbookGraphData, ThrowOnError>): RequestResult<GetWorkbookGraphResponses, GetWorkbookGraphErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetWorkbookGraphResponses, GetWorkbookGraphErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workbooks/{workbook_id}/graph',
            ...options
        });
    }
}

export class DefaultService {
    /**
     * Health Check
     */
    public static healthCheckHealthyGet<ThrowOnError extends boolean = true>(options?: Options<HealthCheckHealthyGetData, ThrowOnError>): RequestResult<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/healthy',
            ...options
        });
    }
    
    /**
     * Deliberate Error
     */
    public static deliberateErrorKaboomGet<ThrowOnError extends boolean = true>(options?: Options<DeliberateErrorKaboomGetData, ThrowOnError>): RequestResult<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/kaboom',
            ...options
        });
    }
}
